/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_codon_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The fraction column reveals synonymous codon preference within each amino acid.`)
};

const es_codon_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La columna de fracción revela la preferencia de codones sinónimos dentro de cada aminoácido.`)
};

const de_codon_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Anteilsspalte zeigt die Präferenz synonymer Codons innerhalb jeder Aminosäure.`)
};

const nl_codon_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De fractiekolom toont de voorkeur voor synonieme codons binnen elk aminozuur.`)
};

const fr_codon_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La colonne fraction révèle la préférence de codons synonymes au sein de chaque acide aminé.`)
};

const it_codon_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La colonna della frazione rivela la preferenza dei codoni sinonimi all'interno di ciascun amminoacido.`)
};

const pt_br2_codon_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A coluna de fração revela a preferência de códons sinônimos dentro de cada aminoácido.`)
};

const pt_codon_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A coluna de fração revela a preferência por codões sinónimos dentro de cada aminoácido.`)
};

const ja_codon_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`割合の列は、各アミノ酸内の同義コドンの選好性を明らかにします。`)
};

const zh_codon_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`比例列揭示了每种氨基酸内部的同义密码子偏好。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const codon_ex3 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.codon_ex3(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("codon_ex3", locale)
	if (locale === "en") return en_codon_ex3(inputs)
	if (locale === "es") return es_codon_ex3(inputs)
	if (locale === "de") return de_codon_ex3(inputs)
	if (locale === "nl") return nl_codon_ex3(inputs)
	if (locale === "fr") return fr_codon_ex3(inputs)
	if (locale === "it") return it_codon_ex3(inputs)
	if (locale === "pt-BR") return pt_br2_codon_ex3(inputs)
	if (locale === "pt") return pt_codon_ex3(inputs)
	if (locale === "ja") return ja_codon_ex3(inputs)
	return zh_codon_ex3(inputs)
};